import { Stack } from '@chakra-ui/react'
import { SectionTitle } from '@!/Store/Common/components/'
import { ScrollableContent, BulkPurchaseTitleItem } from '@!/Store/Home/components'

/* 横スクロール型のまとめ買い作品リスト */
export const ScrollableBulkPurchaseTitleList = ({ titles }) => {
  const sectionTitle = 'まとめ買い作品'
  const gtmClick = `home_bulkpurchase`

  return (
    <Stack gap={0} mx={4}>
      <SectionTitle title={sectionTitle} url={`/store/bulk_purchase_titles`} gtmClick={gtmClick} />
      <ScrollableContent>
        <Stack direction="row" gap={0}>
          {titles.map((title, index) => (
            <BulkPurchaseTitleItem key={`list-${index}-${title.title_id}`} title={title} gtmClick={gtmClick} />
          ))}
        </Stack>
      </ScrollableContent>
    </Stack>
  )
}
